export type NotificationType = 'OFFER' | 'PLAN' | 'REPORT' | 'INVOICE' | 'LEGAL' | 'FINANCE';

export const notificationTypeLabels: Record<NotificationType, string> = {
  OFFER: 'Teklif',
  PLAN: 'Plan',
  LEGAL: 'Yasal İşlemler',
  REPORT: 'Rapor',
  INVOICE: 'Fatura',
  FINANCE: 'Finans',
};

// Mantık silsilesi sırası: Teklif, Plan, Rapor, Fatura, Finans, Yasal İşlemler
export const notificationTypeOrder: NotificationType[] = [
  'OFFER',
  'PLAN',
  'LEGAL',
  'REPORT',
  'INVOICE',
  'FINANCE'
];

export const sortNotificationTypes = (types: NotificationType[]): NotificationType[] => {
  const orderMap = new Map<NotificationType, number>();
  notificationTypeOrder.forEach((t, i) => orderMap.set(t, i));
  return [...types].sort((a, b) => (orderMap.get(a) ?? 999) - (orderMap.get(b) ?? 999));
};

export const notificationTypeOptions = notificationTypeOrder.map((value) => ({
  label: notificationTypeLabels[value],
  value,
}));

export const filterNotificationTypeOption = (
  input: string,
  option?: { label?: unknown },
) => {
  const label = typeof option?.label === 'string' ? option.label : '';
  return label.toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'));
};
